import { TProps } from './types/TProps';

export const EndpointSection = ({ title, children }: TProps) => (
  <div>
    <h3 className="mb-2 text-xs font-semibold uppercase tracking-wide text-[var(--color-text-muted)]">{title}</h3>
    {children}
  </div>
);
